import React from 'react';
import './Background.css';

const Background = () => {
  return (
    <>
      {/* Gold accent bars */}
      <div className="gold-accent gold-accent-top"></div>
      <div className="gold-accent gold-accent-bottom"></div>

      {/* Floating blobs */}
      <div className="deco-circle deco-circle-1"></div>
      <div className="deco-circle deco-circle-2"></div>
      <div className="deco-circle deco-circle-3"></div>

      {/* Blueprint grid background */}
      <div className="bg-canvas">
        <svg xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid-sm" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M40 0 L0 0 0 40" fill="none" stroke="#0D3B6E" strokeWidth="0.5"/>
            </pattern>
            <pattern id="grid-lg" width="200" height="200" patternUnits="userSpaceOnUse">
              <rect width="200" height="200" fill="url(#grid-sm)"/>
              <path d="M200 0 L0 0 0 200" fill="none" stroke="#0D3B6E" strokeWidth="1.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-lg)"/>
          {/* Blueprint accent lines */}
          <circle cx="75%" cy="20%" r="120" fill="none" stroke="#D4A017" strokeWidth="0.8" strokeDasharray="8 4"/>
          <circle cx="75%" cy="20%" r="200" fill="none" stroke="#D4A017" strokeWidth="0.4" strokeDasharray="4 8"/>
          <circle cx="15%" cy="75%" r="90" fill="none" stroke="#0D3B6E" strokeWidth="0.8" strokeDasharray="6 4"/>
        </svg>
      </div>

      {/* Architectural skyline silhouette */}
      <div className="arch-silhouette">
        <svg viewBox="0 0 1440 280" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax slice" style={{display:'block'}}>
          <defs>
            <linearGradient id="skyFade" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#0D3B6E" stopOpacity="0.06"/>
              <stop offset="100%" stopColor="#0D3B6E" stopOpacity="0.12"/>
            </linearGradient>
          </defs>
          {/* Building silhouettes */}
          <g fill="url(#skyFade)">
            {/* Tower 1 */}
            <rect x="60" y="80" width="80" height="200"/>
            <rect x="90" y="40" width="20" height="60"/>
            {/* Windows tower 1 */}
            <rect x="68" y="100" width="14" height="18" fill="rgba(212,160,23,0.15)"/>
            <rect x="90" y="100" width="14" height="18" fill="rgba(212,160,23,0.15)"/>
            <rect x="112" y="100" width="14" height="18" fill="rgba(212,160,23,0.15)"/>
            <rect x="68" y="130" width="14" height="18" fill="rgba(212,160,23,0.15)"/>
            <rect x="90" y="130" width="14" height="18" fill="rgba(212,160,23,0.15)"/>
            <rect x="112" y="130" width="14" height="18" fill="rgba(212,160,23,0.15)"/>

            {/* Tower 2 */}
            <rect x="160" y="120" width="60" height="160"/>
            <rect x="175" y="90" width="30" height="40"/>

            {/* Big tower center-left */}
            <rect x="240" y="20" width="100" height="260"/>
            <rect x="265" y="0" width="50" height="30"/>
            <rect x="248" y="50" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="274" y="50" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="300" y="50" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="248" y="82" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="274" y="82" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="300" y="82" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="248" y="114" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="274" y="114" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="300" y="114" width="18" height="22" fill="rgba(212,160,23,0.2)"/>

            {/* Middle buildings */}
            <rect x="360" y="100" width="70" height="180"/>
            <rect x="450" y="60" width="90" height="220"/>
            <rect x="465" y="30" width="60" height="40"/>
            <rect x="460" y="80" width="16" height="20" fill="rgba(212,160,23,0.15)"/>
            <rect x="485" y="80" width="16" height="20" fill="rgba(212,160,23,0.15)"/>
            <rect x="510" y="80" width="16" height="20" fill="rgba(212,160,23,0.15)"/>

            {/* Dome building */}
            <ellipse cx="610" cy="90" rx="55" ry="20" fill="rgba(13,59,110,0.07)"/>
            <rect x="555" y="90" width="110" height="190"/>

            <rect x="680" y="70" width="80" height="210"/>
            <rect x="690" y="40" width="60" height="40"/>
            {/* Windows */}
            <rect x="688" y="90" width="14" height="18" fill="rgba(212,160,23,0.15)"/>
            <rect x="710" y="90" width="14" height="18" fill="rgba(212,160,23,0.15)"/>
            <rect x="732" y="90" width="14" height="18" fill="rgba(212,160,23,0.15)"/>

            {/* Right side */}
            <rect x="780" y="30" width="120" height="250"/>
            <rect x="805" y="0" width="70" height="38"/>
            <rect x="788" y="60" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="815" y="60" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="842" y="60" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="870" y="60" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="788" y="92" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="815" y="92" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="842" y="92" width="18" height="22" fill="rgba(212,160,23,0.2)"/>
            <rect x="870" y="92" width="18" height="22" fill="rgba(212,160,23,0.2)"/>

            <rect x="920" y="100" width="65" height="180"/>
            <rect x="1000" y="55" width="88" height="225"/>
            <rect x="1014" y="20" width="60" height="42"/>

            <rect x="1100" y="80" width="72" height="200"/>
            <rect x="1188" y="110" width="58" height="170"/>
            <rect x="1260" y="60" width="95" height="220"/>
            <rect x="1278" y="20" width="60" height="48"/>
            <rect x="1370" y="100" width="70" height="180"/>
          </g>
          {/* Ground line */}
          <line x1="0" y1="278" x2="1440" y2="278" stroke="#0D3B6E" strokeWidth="1" strokeOpacity="0.12"/>
        </svg>
      </div>
    </>
  );
};

export default Background;
